var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"root"},[(_vm.dim.shouldShow)?_c('tech-scribble',{staticClass:"tech-scribble",attrs:{"traceColor":"rgba(0,0,0,0.12)","traceFillColor":"transparent","restartAfter":_vm.loopTime,"width":_vm.dim.width,"height":_vm.dim.height}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"router-content"},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7303d802","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 